import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const TreatmentPlanView = ({ plans }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  return (
    <div className="ph15">
      {(plans ?? reqDet?.treatmentPlas)?.map((pln) => {
        return (
          <div key={pln?.id} className="mt10">
            <Typography className="font-bold fs14 blue-color">
              {pln?.planName}
            </Typography>

            {pln?.appointmentTreatmentPlan?.map((ques) => {
              return (
                <div key={ques?.treatmentId} className="mt5">
                  <Typography className="fs12 blue-color txt-semi-bold">
                    {ques?.question}
                  </Typography>
                  {ques?.questionType === "shortAnswer" ||
                  ques?.questionType === "paragraph" ||
                  ques?.questionType === "multipleChoice" ? (
                    <Typography className="fs12 font-medium black10">
                      {ques?.answer?.[0]}
                    </Typography>
                  ) : ques?.questionType === "checkboxes" ? (
                    <Typography className="fs12 font-medium black10">
                      {ques?.answer?.join(", ")}
                    </Typography>
                  ) : ques?.questionType === "fileupload" ? (
                    ques?.files?.map((fle) => (
                      <div className="mt2" key={fle}>
                        <a href={fle} className="fs12 blue-color txt-regular">
                          {fle}
                        </a>
                      </div>
                    ))
                  ) : null}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default TreatmentPlanView;
